import { Machine } from "./Machine";

export class Instalation {
    idinstalation: number;
    name: string;
    address: string;
    city: string;
    lat: number;
    lng: number;
    type: number;
    active: boolean;
    machines: Machine[];


    constructor() {
        this.name = '';
        this.address = '';
        this.city = '';
        this.type = 0;
        this.active = true;
        this.lat = 41.9301200; //Vic
        this.lng = 2.2548600; //Vic
        this.idinstalation = 0;
        this.machines = [];
    }
}